import HttpService from "./htttp.service";

class PropertyService {
    getList = async(payload) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "properties";
        return await HttpService.get(getListEndPoint, payload, token);
    }
    getPropertyLeasesList = async(payload, id) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "properties/" + id + "/leases";
        return await HttpService.get(getListEndPoint, payload, token);
    }
    getPropertyLeasesExcel = async(payload, id) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "properties/" + id + "/leases";
        // console.log(getListEndPoint, payload);
        return await HttpService.get(getListEndPoint, payload, token);
    };
    getPropertyLeasesInvoiceList = async(payload) => {
        const token = localStorage.getItem("token");
        console.log(payload);
        const getListEndPoint = "properties/report/pending-amount-excel";
        return await HttpService.post(getListEndPoint, payload, token, true);
    }
}

export default new PropertyService();
